import { ServiceRequest } from '@/types/conductor'
import { getSessionId } from '@/utils/session.util'
import { getClientAgentString, getBaseRequestData } from '@/utils/service.util'

let _requestId = 100

// ----------------- Request ID -----------------
export function allocateRequestId(): number {
  return ++_requestId
}

// ----------------- Base Field Application -----------------
export function applyRequestBaseFields<T extends ServiceRequest>(serviceRequest: T): T {
  const sessionId = getSessionId()
  const requestWithBaseFields = applyRequestBaseFieldsWithoutSession(serviceRequest)

  return {
    ...requestWithBaseFields,
    sessionId,
  }
}

export function applyRequestBaseFieldsWithoutSession<T extends ServiceRequest>(serviceRequest: T): T {
  const baseData = getBaseRequestData()

  return {
    ...serviceRequest,
    ...baseData,
  }
}